<div class="container">
  <div class="table-container">
    <div class="title-wrapper ic1-mb-20">
      <div class="title-desc">
        <h1 class="title" translate>MULTI_CERT_PAGE.TITLE</h1>
        <div class="desc" translate>MULTI_CERT_PAGE.DESC</div>
      </div>
      <!-- BARRA DI RICERCA -->
      <div class="search-bar">
        <img src="assets/images/search-icon.svg" />
        <input
          class="search-input"
          type="search"
          [(ngModel)]="searchString"
          name="searchString"
          (ngModelChange)="onSearch()"
          [placeholder]="'MULTI_CERT_PAGE.SEARCH' | translate" />
      </div>
    </div>

    <!-- CARD VISUALIZZATO SE NON TROVA NESSUN CERTIFICATO -->
    <div class="ic1-my-16">
      <ng-ui-kit-card
        *ngIf="filteredCertificateList.length === 0"
        type="summative"
        [text]="'MULTI_CERT_PAGE.TABLE.NO_CERT_FOUND' | translate"
        [attr.translate-key]="
          'MULTI_CERT_PAGE.TABLE.NO_CERT_FOUND'
        "></ng-ui-kit-card>
    </div>

    <!-- NUMERO CERTIFICATI E FILTRI D'ORDINAMENTO -->
    <div
      *ngIf="filteredCertificateList.length > 0"
      class="title-wrapper ic1-mb-12">
      <div
        class="certificate-numbers"
        [HTMLTranslate]="
          'MULTI_CERT_PAGE.CERTIFICATE_NUMBERS'
            | translate
              : {
                  currentStart: currentStart,
                  currentEnd: currentEnd,
                  total: totalItems,
                }
        "></div>
      <!-- ordinamento direttamente nelle colonne della tabella -->
      <!-- <div class="order-wrapper">
        <span class="pc" translate>MULTI_CERT_PAGE.ORDER_BY</span>
        <div class="order-by-dropdown">
          <ng-ui-kit-dropdown
            [items]="orderOptions"
            [open]="isDropdownOpen"
            (toggle)="toggleDropdown()"
            (onChange)="onSelectOrder($event.value)">
            <ng-ui-kit-button
              dropdownToggle
              class="order-button"
              color="text"
              size="sm"
              [iconAfter]="isDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down'"
              [label]="'MULTI_CERT_PAGE.ORDER_BY' | translate"
              [attr.translate-key]="'MULTI_CERT_PAGE.ORDER_BY'">
            </ng-ui-kit-button>
          </ng-ui-kit-dropdown>
        </div>
        <div class="mobile" (click)="toggleShowFilter()">
          <span class="show-filter" translate
            >MULTI_CERT_PAGE.FILTER.TITLE</span
          >
          <img
            [ngClass]="{ reversed: showFilter }"
            src="assets/images/arrow-down.svg" />
        </div>
      </div> -->
    </div>

    <!-- TABELLA CERTIFICATI -->
    <div *ngIf="filteredCertificateList.length > 0" class="table-container">
      <ng-ui-kit-table
        icId="certificates-table"
        [striped]="true"
        [sortable]="true"
        [columns]="tableColumns"
        [items]="tableItems"
        (onClickRow)="onTableRowClick($event)"
        emptyMessage="Nessun certificato trovato">
      </ng-ui-kit-table>
    </div>

    <!-- PAGINAZIONE -->
    <div
      class="ic1-flex ic1-items-center ic1-justify-center ic1-mt-12 ic1-mb-12"
      *ngIf="totalItems > itemsPerPage">
      <ng-ui-kit-paginator
        [items]="totalItems"
        size="sm"
        (onPageChange)="onPageChanged($event)"
        [itemsPerPage]="itemsPerPage">
      </ng-ui-kit-paginator>
    </div>
  </div>

  <!-- FILTRI -->
  <div class="filter-container">
    <div class="filter" [ngStyle]="showFilter && { display: 'block' }">
      <div class="title-wrapper ic1-mb-24">
        <div class="filter-title" translate>MULTI_CERT_PAGE.FILTER.TITLE</div>
        <button
          class="reset-text"
          (click)="resetFilters()"
          [attr.aria-label]="'MULTI_CERT_PAGE.FILTER.RESET' | translate"
          translate>
          MULTI_CERT_PAGE.FILTER.RESET
        </button>
      </div>

      <div class="sub-title" translate>MULTI_CERT_PAGE.FILTER.DATE</div>

      <hr aria-hidden="true" />

      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <div class="ic1-mt-12">
          <ng-ui-kit-input
            formControlName="startDate"
            name="startDate"
            autocomplete="startDate"
            placeholder="gg/mm/aaaa"
            type="date"
            icName="startDate"
            icId="startDate"
            [label]="'MULTI_CERT_PAGE.FILTER.FROM' | translate"
            status="informative">
          </ng-ui-kit-input>
        </div>

        <div>
          <!-- NOTA: il componente ng-ui-kit-input type="date" non accetta il minDate, in caso di aggiornamento la variabile è già presente nel controller -->
          <ng-ui-kit-input
            formControlName="endDate"
            name="endDate"
            autocomplete="endDate"
            placeholder="gg/mm/aaaa"
            type="date"
            icName="endDate"
            icId="endDate"
            [label]="'MULTI_CERT_PAGE.FILTER.TO' | translate"
            status="informative">
          </ng-ui-kit-input>
        </div>
      </form>

      <div class="sub-title" translate>MULTI_CERT_PAGE.STATUS.TITLE</div>

      <hr aria-hidden="true" />

      <div class="checkbox-container">
        <div class="checkbox-content all-status">
          <div>
            <input
              type="checkbox"
              name="status"
              value="all"
              id="all"
              [checked]="checkAllStatus"
              (change)="onFilterChange($event)" />
            <label class="checkbox-label ic1-ml-8" for="all" translate
              >MULTI_CERT_PAGE.STATUS.ALL</label
            >
          </div>
          <!-- <img src="assets/images/close-dropdown.svg" /> -->
        </div>

        <div class="checkbox-content ic1-ml-8">
          <input
            type="checkbox"
            name="status"
            value="active"
            [checked]="checkActive"
            id="active"
            (change)="onFilterChange($event)" />
          <label class="checkbox-label" for="active" translate
            >MULTI_CERT_PAGE.STATUS.ACTIVE</label
          >
        </div>

        <div class="checkbox-content ic1-ml-8">
          <input
            type="checkbox"
            name="status"
            value="revoked"
            id="revoked"
            [checked]="checkRevoked"
            (change)="onFilterChange($event)" />
          <label class="checkbox-label" for="revoked" translate
            >MULTI_CERT_PAGE.STATUS.REVOKED</label
          >
        </div>

        <div class="checkbox-content ic1-ml-8">
          <input
            type="checkbox"
            name="status"
            value="expire"
            [checked]="checkExpire"
            id="expire"
            (change)="onFilterChange($event)" />
          <label class="checkbox-label" for="expire">
            <span translate>MULTI_CERT_PAGE.STATUS.EXPIRING</span>
            /
            <span translate>MULTI_CERT_PAGE.STATUS.EXPIRED</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
